export default "__VITE_ASSET__CXhg3juF__"